import React, { useState } from "react";
import { showError } from "component/utils/SweetAlert";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

function BulanTanggal({ onDownload, onLoading, title }) {
  const [date, setDate] = useState("");

  const handleSubmit = (mode) => {
    if (!date) {
      showError("Silakan pilih tanggal terlebih dahulu.");
      return;
    }

    const formattedDate = date instanceof Date
      ? date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0")
      : date;

    onDownload({
      selectedDate: formattedDate,
      mode, // 'day' atau 'month'
    });
  };

  return (
    <div className="row px-4 mt-3">
      <div className="card shadow mb-4">
        <div className="card-body">
          <h6 className="mb-3">{title}</h6>

          {/* Input Tanggal */}
          <div className="row mb-3 align-items-center">
            <label className="col-sm-2 form-label">Tanggal</label>
            <div className="col-sm-3">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bx bx-calendar"></i>
                </span>
                <Flatpickr
                  className="form-control form-control-sm"
                  value={date}
                  options={{ dateFormat: "Y-m-d", maxDate: "today" }}
                  onChange={([selectedDate]) => setDate(selectedDate)}
                />
              </div>
            </div>
            <div className="col-sm-7">       
              <div className="text-end">
                <button
                  type="button"
                  className="btn btn-primary me-5"
                  onClick={() => handleSubmit("day")}
                  disabled={onLoading}
                >
                  {onLoading ? "Loading..." : "by Day"}
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => handleSubmit("month")}
                  disabled={onLoading}
                >
                  {onLoading ? "Loading..." : "by Month"}
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default BulanTanggal;
